import React from 'react'
import { Image } from '@shared/components/image'
import { Section } from '@shared/components/section'

import styles from './style.module.scss'

const services = [
	{
		image: 'FZ.png',
		title: 'Соблюдаем требования Федерального закона №259-ФЗ',
	},
	{
		image: 'logo-operators.png',
		title: 'Состоим в Ассоциации операторов инвестиционных платформ',
	},
] as Array<{ image: string; title: string; href?: string }>

export const View = () => {
	return (
		<Section className={styles.wrapper}>
			<h1 className={styles.title}>Документы</h1>
			<div className={styles.columns}>
				<h2 className={styles.subtitle}>Платформа цифровых решений для кредитования</h2>
				<h3 className={styles.h5}>
					Мы создаём технологичные кредитные продукты совместно с другими финансовыми компаниями.
					Объединяем экспертизу и технологии, чтобы клиенты получали удобные и эффективные решения.
				</h3>
			</div>
			<ul className={styles.services}>
				{services.map(({ image, title, href }, index) => {
					const Content = (
						<>
							<div className={styles.logo}>
								<Image lazy name={image} />
							</div>
							<p className={styles.serviceTitle}>{title}</p>
						</>
					)

					if (href) {
						return (
							<a
								key={index}
								className={styles.service}
								href={href}
								target='_blank'
								rel='noopener noreferrer nofollow'
							>
								{Content}
							</a>
						)
					}

					return (
						<li key={index} className={styles.service}>
							{Content}
						</li>
					)
				})}
			</ul>
		</Section>
	)
}
